/** `guest:{campaignId}:{siteId}` — token anônimo de um veículo. */
export function guestAccessFromUserId(userId) {
  const match = String(userId || "").match(/^guest:(\d+):(\d+)$/);
  if (!match) return null;
  return {
    campaign_id: Number(match[1]),
    site_id: Number(match[2]),
  };
}

function decodeJwtPayload(token) {
  const part = String(token || "").split(".")[1];
  if (!part) return null;
  const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
  const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
  return JSON.parse(atob(padded));
}

/** JWT cru em `/analytics/access/<jwt>`, inclusive depois de um redirect do catch-all. */
export function accessTokenFromPath(value) {
  if (typeof value !== "string" || !value) return null;
  const marker = "/analytics/access/";
  const at = value.indexOf(marker);
  if (at < 0) return null;
  const raw = value.slice(at + marker.length).split(/[?#]/)[0];
  if (!raw) return null;
  try {
    return decodeURIComponent(raw);
  } catch (error) {
    return raw;
  }
}

export function guestAccessFromToken(token) {
  if (typeof token !== "string" || token.split(".").length !== 3) return null;
  try {
    const payload = decodeJwtPayload(token);
    if (!payload || payload.is_guest !== true) return null;
    return guestAccessFromUserId(payload.user_id);
  } catch (error) {
    return null;
  }
}

export function guestAccessFromSession() {
  if (typeof window === "undefined") return null;
  return guestAccessFromToken(window.localStorage.getItem("analytics_jwt"));
}

/**
 * Link `/analytics/access/<jwt>` vira a sessão do veículo.
 * Apaga o sid anterior para o guard e o `me()` não ficarem na campanha antiga.
 */
export function adoptGuestToken(token) {
  if (typeof window === "undefined") return null;
  const guest = guestAccessFromToken(token);
  if (!guest) return null;
  window.localStorage.setItem("analytics_jwt", token);
  window.localStorage.setItem("sessionId", "guest");
  window.localStorage.removeItem("reportsSessionId");
  return guest;
}

/** JWT guest adotado por link. Enquanto `sessionId` for `guest`, ele não perde para o sid da conta. */
export function adoptedGuestJwt() {
  if (typeof window === "undefined") return null;
  if (window.localStorage.getItem("sessionId") !== "guest") return null;
  const token = window.localStorage.getItem("analytics_jwt");
  if (!guestAccessFromToken(token)) return null;
  return token;
}

export function adoptedGuestAccess() {
  return guestAccessFromToken(adoptedGuestJwt());
}

export function guestSitePath(access) {
  if (!access) return null;
  return `/dashboard/campaign/${access.campaign_id}/site/${access.site_id}`;
}

/** `trpc` = sessão no cookie; o restante é o sid opaco da conta. JWT e `guest` não contam. */
export function isAccountSessionMarker(value) {
  if (typeof value !== "string" || !value || value === "guest") return false;
  if (value.split(".").length === 3) return false;
  if (value === "trpc") return true;
  return value.length >= 16;
}

export function accountSessionMarker() {
  if (typeof window === "undefined") return null;
  const reports = window.localStorage.getItem("reportsSessionId");
  const sessionId = window.localStorage.getItem("sessionId");
  if (isAccountSessionMarker(reports) && reports !== "trpc") return reports;
  if (isAccountSessionMarker(sessionId)) return sessionId;
  return null;
}

export function dropGuestTokenForAccountSession() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem("analytics_jwt");
}
